import React, { useState, useEffect } from 'react';
import { nlPost } from '../apis/notLoginApi';
import TextViewer from '../components/inputComponents/TextViewer';

const Footer = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMembershipModalOpen, setIsMembershipModalOpen] = useState(false);
  const [trmData, setTrmData] = useState(['', '', '']);
  const [isLoading, setIsLoading] = useState(true);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleOpenMembershipModal = () => setIsMembershipModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleCloseMembershipModal = () => setIsMembershipModalOpen(false);

    const formatContent = content => {
      const withoutMarkdown = content.replace(
        /!\[.*?\]\((?!http)(.*?)\)|#/g,
        match => {
          if (match === '#') return '';
          return match;
        }
      );

      return withoutMarkdown
        .replace(/\s+/g, ' ')
        .trim()
        .replaceAll('&middot;', ' ')
        .replace(/\\/g, ' ');
    };


  useEffect(() => {
    const init = async () => {
      const url = '/member/mngTrms/list.do';

      try {
        const response = await nlPost(url, {});

        if (response instanceof Error) {
          modalService.alert('알림 - 약관 정보를 가져오는데 실패했습니다.');
        } else {
          setTrmData([
            response?.pTrms?.trmsCn,
            response?.uTrms?.trmsCn,
            response?.bTrms?.trmsCn,
            response?.sTrms?.trmsCn,
          ]);
          setIsLoading(false);
        }
      } catch (e) {
        setTrmData(['', '', '']);
      }
    };

    init();
  }, []);

  return (
    <>
      <footer
        id="footer"
        // style={{ bottom: '0', position: 'fixed', width: '100%' }}
      >
        <div className="inner">
          <div
            className="f-logo"
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
            }}
          >
            <img
              src={require('../assets/img/layout/logo.svg').default}
              className="logo-im"
              alt="산업재해부담작업예방플랫폼"
            />
          </div>

          <div className="f-btm">
            <div className="f-btm-text">
              <div
                className="f-menu"
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  width: '33.3%',
                  paddingTop: '0',
                  marginTop: '0',
                }}
              >
                <button
                  className="point page-link"
                  onClick={handleOpenModal}
                  style={{ display: 'inline-block' }}
                >
                  <strong>전자상거래표준약관</strong>
                </button>
                &nbsp;&nbsp;
                <button
                  className="point page-link"
                  onClick={handleOpenMembershipModal}
                  style={{ display: 'inline-block' }}
                >
                  <strong>개인정보처리방침</strong>
                </button>
              </div>
              <p
                className="f-copy"
                style={{ width: '66.6%', textAlign: 'right' }}
              >
                <span>
                  <strong>(주) 글로비트</strong>
                </span>
                <span> 제주특별자치도 제주시 중앙로 175, 3층</span>
                &nbsp;&nbsp;
                <span>
                  사업자등록번호 : 616-81-92018 | 통신판매업 신고번호:
                  2022-제주아라-0023
                </span>
                <br />
                &nbsp;&nbsp;
                <span>대표 : 김형수</span>
                &nbsp;&nbsp;
                <br />
                <span>Tel. 064-727-9106 | Email. help@gbit.kr</span>
                <br />
                <span>
                  ©2011 globit co.ltd - 산업재해부담작업예방플랫폼. All rights
                  reserved.
                </span>
              </p>
            </div>
          </div>
        </div>
      </footer>

      {isModalOpen && (
        <section
          id="modal_sample_03"
          className="modal fade shown in"
          style={{ display: 'block' }}
          role="dialog"
          aria-labelledby="tit_modal_sample_03"
        >
          <div className="modal-back in" onClick={handleCloseModal}></div>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h2 id="tit_modal_sample_03" className="modal-title">
                  전자상거래표준약관 
                </h2>
              </div>
              <div className="modal-conts">
                <p>
                  {isLoading ? (
                    '약관 내용을 불러오는 중...'
                  ) : (
                    <TextViewer content={trmData[2]} />
                  )}
                </p>
              </div>
              <div className="modal-btn btn-wrap both">
                <button
                  type="button"
                  className="btn tertiary md close-modal"
                  onClick={handleCloseModal}
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </section>
      )}

      {isMembershipModalOpen && (
        <section
          id="modal_sample_03"
          className="modal fade shown in"
          style={{ display: 'block' }}
          role="dialog"
          aria-labelledby="tit_modal_sample_03"
        >
          <div
            className="modal-back in"
            onClick={handleCloseMembershipModal}
          ></div>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h2 id="tit_modal_sample_03" className="modal-title">
                  개인정보처리방침 
                </h2>
              </div>
              <div className="modal-conts">
                <p>
                  {isLoading ? (
                    '약관 내용을 불러오는 중...'
                  ) : (
                    <TextViewer content={trmData[3]} />
                  )}
                </p>
              </div>
              <div className="modal-btn btn-wrap both">
                <button
                  type="button"
                  className="btn tertiary md close-modal"
                  onClick={handleCloseMembershipModal}
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Footer;
